import "./IneligibleWarningIFrame.scss";

import { IneligibleCoverageReasonsType } from "config";
import { useAffiliateIntegration } from "modules";

interface IIneligibleWarningIFrameProps {
  ineligibilityReason: IneligibleCoverageReasonsType;
}

export default function IneligibleWarningIFrame({
  ineligibilityReason,
}: IIneligibleWarningIFrameProps) {
  const { iframeHeight, iframeSrc } = useAffiliateIntegration({
    ineligibilityReason,
  });

  if (!iframeSrc) {
    return null;
  }

  return (
    <iframe
      className="ineligible-warning__iframe"
      src={iframeSrc}
      style={{ height: iframeHeight }}
    />
  );
}
